import { log } from 'log';
import { useCallback } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

export const useRequestNativePacket = ({
    license,
    transactionID,
    userId,
    identifierType
}) => {
    return useCallback(() => {
        log('gcReq', { transactionID, license });

        htcmdService.sendMessage('geofencingrequest', {
            provider: 'geocomply',
            license,
            transactionID,
            userId,
            identifierType
        });
    }, [
        license,
        transactionID,
        userId,
        identifierType
    ]);
};
